import { redirect } from "react-router-dom";
import { STAFF_POST_API, 
         STAFF_PATCH_API, 
         STAFF_DELETE_API,
         USER_PASSWORD_RECOVERY_LINK_GET_API } from '../../constants/apis';
import { STAFF_LIST_PATH, LOGIN_PATH } from '../../constants/paths';
import {postModel, patchModel, deleteModel, getModel} from '../../utils/functions';
import {DEFAULT_UNKNOWN_ERROR_MESSAGE} from '../../constants/constants';


export async function staffAction({ params, request }) {
    const requestData = await request.json();

    let data;

    if (requestData !== null) {
        if (requestData.resetWarnings) {        
            return {
                message: "",
                parameters: []
            };
        }
        if (requestData.copyPasswordLink) {
            const recoveryPath = await getModel(USER_PASSWORD_RECOVERY_LINK_GET_API.replace('{id}', params.user_id));

            const fullPath = `${window.location.protocol}//${window.location.host}${recoveryPath}`;

            const permissionStatus = await navigator.permissions.query({name: 'clipboard-write'});

            let passwordRecoveryLinkCopied = false;

            if(permissionStatus.state === 'granted') {
                await navigator.clipboard.writeText(fullPath);
                passwordRecoveryLinkCopied = true;
            }
            else {
                window.open(fullPath, '_blank');
            }

            return {
                passwordRecoveryLinkCopied,
                message: "",
                parameters: []
            };
        }
    
        data = requestData.data;
    
        if (data.password.length <= 0) {
            delete data.password;
            delete data.password_confirmation;
        }
        else if(data.password !== data.password_confirmation) {
            return {
                message: "Confirmarção de senha não bate.",
                parameters: ['password', 'password_confirmation']
            };
        }
    }

    try {
        switch (request.method) {
            case "POST":
                await postModel(STAFF_POST_API, data);

                return redirect(STAFF_LIST_PATH);
            case "PATCH":
                await patchModel(`${STAFF_PATCH_API}${params.user_id}`, data);

                return redirect(STAFF_LIST_PATH);
            case "DELETE":
                await deleteModel(`${STAFF_DELETE_API}${params.user_id}`);
                
                return redirect(STAFF_LIST_PATH);
            default:
                return {
                    message: "Esta página possui erros de implementação/desenvolvimento.",
                    parameters: []
                };
        }
    }
    catch(errors) {
        let message = [];
        let parameters = [];

        if(errors instanceof Array) {
            for(let error of errors) {
                if(error.code === 103) {
                    for(let parameter of error.parameters) {
                        if(parameter.name === 'email') {
                            message.push('E-mail já cadastrado');
                            parameters.push('email');
                        }
                    }
                }
                else if(error.code === 203) {
                    if(error.message.includes('Requires higher access level')) {
                        message.push('Você não possui permissão para cadastrar este email. Por favor, entre em contato com seu gerente');
                        parameters.push('email');
                    }
                }
                else if(error.code === 208) {
                    if(error.message.includes('User can not inactivate himself')) {
                        message.push('Usuário não pode se desativar');
                        parameters.push('is_active');
                    }
                    else if(error.message.includes('Invalid email')) {
                        message.push('Email inválido');
                        parameters.push('email');
                    }
                    else if(error.message.includes('User id might be invalid')) {
                        message.push('Usuário não encontrado');
                    }
                }
                else if(error.code === 209) {
                    // message.push('Sessão do usuário expirada');
                    return redirect(LOGIN_PATH);
                }
            }
        }

        if (message.length <= 0) {
            message = [DEFAULT_UNKNOWN_ERROR_MESSAGE];
        }
    
        return {
            parameters,
            message: `${message.join('; ')}.`
        };
    }
  };